import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            getCurrentTheme: 'global/getCurrentTheme'
        })
    },
    methods: {
        hoverColor(item) {
            return this.getCurrentTheme === 'light-theme'
                ? item.hover_color_light
                : item.hover_color_dark || 'var(--surface-black-t3)';
        },
        baseColor(item) {
            return this.getCurrentTheme === 'light-theme'
                ? item.text_color_light
                : item.text_color_dark || 'var(--color-gray-400)';
        },
        setActiveClass(path) {
            const getLastSegment = fullPath => {
                const segments = fullPath.split('/').filter(segment => segment.length > 0);
                return segments[segments.length - 1] || '';
            };

            const currentSegment = getLastSegment(this.$route.path);
            const linkSegment = getLastSegment(path);

            return currentSegment.includes(linkSegment);
        },
        getAnchorStyle(item) {
            const fontSize = item.text_size ? `${item.text_size}px` : '13px';
            let baseColor;
            let borderColor;

            if (this.setActiveClass(item.link)) {
                baseColor = this.hoverColor(item);
                borderColor = baseColor;
            } else {
                baseColor = this.baseColor(item);
                borderColor = 'transparent';
            }

            return {
                'font-size': fontSize,
                color: baseColor,
                borderColor: borderColor
            };
        },
        handleMouseOver(event, item) {
            event.currentTarget.style.color = this.hoverColor(item);
            event.currentTarget.style.borderColor = this.hoverColor(item);
        },
        handleMouseLeave(event, item) {
            event.currentTarget.style.color = this.setActiveClass(item.link) ? this.hoverColor(item) : this.baseColor(item);
            event.currentTarget.style.borderColor = this.setActiveClass(item.link) ? this.hoverColor(item) : 'transparent';
        }
    }
};
